import styled from "@emotion/styled";
import { BaseCell } from "src/components/Table/Cells/shared";
import { dayAndDateFromDate } from "src/utils";

const CellContainer = styled(BaseCell)``;

interface TargetDateCellProps {
  date: string;
}

export const TargetDateCell = ({ date }: TargetDateCellProps) => (
  <CellContainer>{dayAndDateFromDate(date)}</CellContainer>
);
